import { FilterKeys } from '@op/components/FilterCommon/types';
import { getKeyMapIdPointMap, getKeyPointMap } from '../utils';

type WithKeyPointType =
  | 'RegionWithLanguage'
  | 'GamesWithAffinity'
  | 'FilterSubmit'
  | 'HistoryFilter'
  | 'dateType';

export type AllFilterPointType = FilterKeys | WithKeyPointType;

type ButtonPointType = {
  [key in AllFilterPointType]: { buttonId: string };
};

// 后续的过滤器只能在后面添加
export const commonFilter: ButtonPointType = {
  FilterSubmit: { buttonId: '10000000' },
  HistoryFilter: { buttonId: '10000001' },
  date: { buttonId: '10000002' },
  invalid: { buttonId: '10000003' },
  refunded: { buttonId: '10000004' },
  starredTag: { buttonId: '10000005' },
  freePlayed: { buttonId: '10000006' },
  recordTimes: { buttonId: '10000007' },
  reviewTimes: { buttonId: '10000008' },
  monitor: { buttonId: '10000009' },
  rating: { buttonId: '100000010' },
  steamRating: { buttonId: '100000011' },
  regionAndLanguage: { buttonId: '100000012' },
  language: { buttonId: '100000013' },
  region: { buttonId: '100000014' },
  sentiment: { buttonId: '100000015' },
  sentimentClause: { buttonId: '100000016' },
  topic: { buttonId: '100000017' },
  hero: { buttonId: '100000018' },
  version: { buttonId: '100000019' },
  platform: { buttonId: '100000020' },
  monitorSource: { buttonId: '100000021' },
  reviewType: { buttonId: '100000022' },
  platformGame: { buttonId: '100000023' },
  hashtag: { buttonId: '100000024' },
  followerRange: { buttonId: '100000025' },
  gptSelect: { buttonId: '100000026' },
  gameType: { buttonId: '100000027' },
  channelType: { buttonId: '100000028' },
  dataSource: { buttonId: '100000029' },
  keyWords: { buttonId: '100000030' },
  videoTag: { buttonId: '100000031' },
  reviewers: { buttonId: '100000032' },
  channelTypeSingle: { buttonId: '100000033' },
  perspective: { buttonId: '100000034' },
  engagementPerformance: { buttonId: '100000035' },
  engagementsRange: { buttonId: '100000036' },
  commentsRange: { buttonId: '100000037' },
  likesRange: { buttonId: '100000038' },
  sharesRange: { buttonId: '100000039' },
  matchedType: { buttonId: '100000040' },
  keywordFilterType: { buttonId: '100000041' },
  liveVenues: { buttonId: '100000042' },
  influencersType: { buttonId: '100000043' },
  steamIds: { buttonId: '100000044' },
  earlyAccess: { buttonId: '100000045' },
  funnys: { buttonId: '100000046' },
  helpfuls: { buttonId: '100000047' },
  gameAffinitys: { buttonId: '100000048' },
  totalPublications: { buttonId: '100000049' },
  avgViews: { buttonId: '100000050' },
  avgEngagementRate: { buttonId: '100000051' },
  brandRelatedPublications: { buttonId: '100000052' },
  brandRelatedAvgViews: { buttonId: '100000053' },
  genreGameList: { buttonId: '100000054' },
  genreGameAndAffinity: { buttonId: '100000055' },
  brandAffinitys: { buttonId: '100000056' },
  genre: { buttonId: '100000057' },
  game: { buttonId: '100000058' },
  RegionWithLanguage: { buttonId: '100000059' },
  GamesWithAffinity: { buttonId: '100000060' },
  channel: { buttonId: '100000061' },
  versionTime: { buttonId: '100000062' },
  dateType: { buttonId: '100000063' },
  newsBate: { buttonId: '100000064' },
  newsCoverageType: { buttonId: '100000065' },
  newsUVPM: { buttonId: '100000066' },
  newsDataSource: { buttonId: '100000067' },
  competitorGames: { buttonId: '100000068' },
  kolTags: { buttonId: '100000069' },
  NIKKE: { buttonId: '100000070' },
  videoType: { buttonId: '100000071' },
  views: { buttonId: '100000072' },
  urlAnalysis: { buttonId: '100000073' },
  sentimentEditStatus: { buttonId: '100000074' },
  intent: { buttonId: '100000075' },
  voiceLanguage: { buttonId: '100000076' },
  subTopicSentiment: { buttonId: '100000077' },
  levelUpGame: { buttonId: '100000078' },
  product: { buttonId: '100000079' },
  keyKol: { buttonId: '100000080' },
  steamPurchase: { buttonId: '100000081' },
  commentsUnderThePostContainingKeywordsIncluded: { buttonId: '100000082' },
  postStream: { buttonId: '100000083' },
  postAuthorType: { buttonId: '100000084' },
  kolRegion: { buttonId: '100000085' },
  xboxEdition: { buttonId: '100000086' },
  videoAITag: { buttonId: '100000087' },
  blackGrayAuthor: { buttonId: '100000088' },
  aigc: { buttonId: '100000089' },
  // TODO: 这几个不通过通用过滤器埋点方法进行埋点
  compareGamesSelection: { buttonId: '' },
  metrics: { buttonId: '' },
  compareDate: { buttonId: '' },
  manyCompareGame: { buttonId: '' },
  keywordPreview: { buttonId: '' },
  gptPreview: { buttonId: '' },
  urlPreview: { buttonId: '' },
  gptAgent: { buttonId: '' },
  gptType: { buttonId: '' },
  gptAnalysisTarget: { buttonId: '' },
  zoneGames: { buttonId: '' },
};

export const FilterButtonPoint: {
  [key in AllFilterPointType]: AllFilterPointType;
} = getKeyPointMap(commonFilter) as {
  [key in AllFilterPointType]: AllFilterPointType;
};

export const FilterNameMapButtonId: {
  [key in AllFilterPointType]: string;
} = getKeyMapIdPointMap(commonFilter) as {
  [key in AllFilterPointType]: string;
};
